import { render, staticRenderFns } from "./AddBindGoodsDialog.vue?vue&type=template&id=5ee1f293&scoped=true&lang=pug&"
import script from "./AddBindGoodsDialog.vue?vue&type=script&lang=ts&"
export * from "./AddBindGoodsDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ee1f293",
  null
  
)

export default component.exports